import * as React from "react";

type Props = {
  id: string,
  name: string
};

const InstitutionReportItem = function(props: Props) {
  return (
    <tr>
      <td>{props.id}</td>
      <td>{props.name}</td>
    </tr>
  );
};
export default InstitutionReportItem;



// WEBPACK FOOTER //
// ./app/javascript/admin_reports/institution_report_item.jsx